import { Field, useField } from 'formik';
import FormText from '@klv/atoms/form-text';

import * as s from './styles/radio-group.module.css';

import type { IRadioGroup } from '../types';

export const RadioGroup = ({
  backgroundColor = 'dark',
  dataTestId,
  id,
  options,
  required = false,
  disabled = 'enabled',
  size = 'medium',
  className = '',
  ...props
}: IRadioGroup) => {
  const [_field, meta] = useField(props);

  return (
    <fieldset
      className={[
        s[backgroundColor],
        s[disabled] ? s[disabled] : '',
        s[size] ? s[size] : '',
        className,
        meta.error ? s.error : '',
      ].join(' ')}
      data-testid={dataTestId}
    >
      {(options?.length > 0) && (
        options.map(({ label, value }) => (
          <label key={value}>
            <Field type="radio" name={props.name} value={value} required={required} disabled={disabled == 'disabled'} />
            <span>{label}</span>
          </label>
        ))
      )}
      {(meta.touched && meta.error && disabled == 'enabled') && <FormText className={s.errorLabel}>{meta.error}</FormText>}
    </fieldset>
  );
};
